import api from '../api';

const routes = require('routes.js.erb');

const searchTemplates = function ({ }, searchParams) {
  return api.get(routes.api_v5_template_index_path(searchParams));
}

const applyTemplate = function ({ }, { templateId, itemId }) {
  return api.post(routes.apply_api_v5_template_path(templateId, { item: itemId }))
}

export { searchTemplates, applyTemplate };